import React, { Component } from 'react';
import i from '../imports';
import Session from '../services/session'


const StyleNormalLink = {
    fontSize: 20,
    textTransform: "uppercase",
    color: "#808080",
    fontWeight: "bold",
    paddingRight: "8px",
    paddingTop: "8px",
    marginRight: "-25px",
    paddingBottom: "8px",
    marginTop: "2px",
    marginBottom: "2px",
    cursor: "pointer"
}

const StyleCurrentDayLink = {
    ...StyleNormalLink,
    color: "#FF5563",
    borderRight: '0.1em solid #FF5563',
}

const StyleNormalMobLink = {
    fontSize: 20,
    textTransform: "uppercase",
    color: "#808080",
    fontWeight: "bold",
    margin: "10px"
}

const StyleCurrentDayMobLink = {
    ...StyleNormalMobLink,
    color: "#FF5563",
    borderRight: "none",
    borderBottom: '0.1em solid #FF5563',

}

const StyleLocationBlockTitle = {
    ...StyleNormalLink,
    color:"#000000",
    paddingBottom: "0px",
}

const StyleLocationBlockText = {
    fontSize: 20,
    color:"#000000",
}

const StyleLocationImage = {
    width: "100%",
    position: "relative",
    //background: url(../imgs/все-о-москве-день-1.jpeg) 50% 50% no-repeat;
    backgroundSize: "cover",
    display: "block",
    content: "",
    paddingTop: "75%"
}

const titleStyle = {
    fontSize: 24,
    fontWeight: "bold",
    paddingTop: "10px",
    paddingBottom: "20px"
}

const TextStyle = {
    align:"left",
    fontSize: 20,
    paddingTop: "6px"
}

class ProgramOutline extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dayNumber: 1,
            daysData : this.props.data,
        }

    }

    dayClick = (m) => {
        this.setState({ 
          dayNumber: m.day
        })
    }

    render() {

        if(this.props.data == undefined)
            return (<div> </div>);
        let currentDay = this.state.dayNumber;
        return (
            <i.PureGridProvider>
                <i.Container  >
                    <i.OnDesktop>
                        <div style={{minHeight:"400px"}}>
                        <i.Row md={12}>
                            <i.Col align="left" style={titleStyle}>
                                {this.props.title}
                            </i.Col>
                        </i.Row>
                        <i.Row >
                            <i.Col md={1} align="left">
                            {this.state.daysData.map(m => 
                                <div style={m.day === currentDay ? StyleCurrentDayLink : StyleNormalLink} onClick={() => this.dayClick(m)}>
                                    {`${Session.model.common.words.day} ${m.day}`} 
                                </div>
                            )}
                            </i.Col>
                            <i.Col md={2} align="left" style={{paddingLeft:"10px"}}>
                                <div style={StyleLocationBlockTitle}>{`${Session.model.common.words.day} ${currentDay}`}</div>
                                <div style={StyleLocationBlockText}>{this.state.daysData.filter(f => f.day == currentDay)[0].dayLocation}</div>
                            </i.Col>
                            <i.Col md={5} align="left">     
                                <div class="program-outline">{this.state.daysData.filter(f => f.day == currentDay)[0].dayDescription}</div>
                            </i.Col>
                            <i.Col md={4} align="left">     
                                <div style={{...StyleLocationImage, backgroundImage: "url(" + this.state.daysData.filter(f => f.day == currentDay)[0].pic + ")" }}></div>
                            </i.Col>
                        </i.Row>
                        </div>
                    </i.OnDesktop>
                    <i.OnAtMostTablet>
                        <i.Row md={12}>
                            <i.Col align="center">
                                <h2>{this.props.title}</h2>
                            </i.Col>
                        </i.Row>
                        <i.Row >
                           <i.Col md={2} align="center" style={{display: "inline-flex"}}>
                                {this.state.daysData.map(m => 
                                    <div style={m.day === currentDay ? StyleCurrentDayMobLink : StyleNormalMobLink} onClick={() => this.dayClick(m)}>
                                        {`${Session.model.common.words.day} ${m.day}`} 
                                    </div>
                                )}  
                            </i.Col>                          
                            <i.Col md={2} align="center" style={{margin: "15px"}}>
                                <div style={StyleLocationBlockTitle}>{`${Session.model.common.words.day} ${currentDay}`}</div>
                                <div>{this.state.daysData.filter(f => f.day == currentDay)[0].dayLocation}</div>
                            </i.Col>
                            <i.Col md={8} style={TextStyle}>     
                                <div style={{fontSize: "20px", textAlign: "left"}}>{this.state.daysData.filter(f => f.day == currentDay)[0].dayDescription}</div>
                            </i.Col>
                        </i.Row>
                    </i.OnAtMostTablet>
                </i.Container>
            </i.PureGridProvider>
        );
    }
}

export default ProgramOutline;